import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'

import PushNotificationPage from '../../pages/PushNotificationPage'

const PushNotificationsRoute = () => {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route path={path} component={PushNotificationPage} />
    </Switch>
  )
}

export default PushNotificationsRoute
